import dayjs from 'utils/dayjs';

export function ExchangeText({
  rateUnavailable,
  retrievalTime
}: {
  rateUnavailable: boolean;
  retrievalTime?: string;
}) {
  return rateUnavailable ? (
    ''
  ) : (
    <p>Last updated at: {dayjs(retrievalTime).toString()}</p>
  );
}
